<template>
  <div>
    <header class="header">
      <div class="header-text">付款给 {{ payOrderInfo.mchName }}</div>
      <div class="header-img">
        <img :src="avatar ? avatar : iconMemberDefault" alt="" />
      </div>
    </header>
    <div class="plus-input">
      <!-- ￥字符 货币的符号-->
      <div class="S">
        <img src="../../assets/icon/S.svg" alt="" />
      </div>

      <!-- 金额输入/展示 -->
      <div class="input-c" style="width: 100%">
        <div v-if="payOrderInfo.amount" class="input-c-div-1">{{ payOrderInfo.amount / 100 }}</div>
        <input type="number" style="height: 120px" v-else v-model="amount" placeholder="请输入金额" />
      </div>
    </div>
    <ul class="plus-ul">
      <!-- 支付板块 -->
      <li style="border-radius: 10px">
        <div class="img-div">
          <div class="stripe-logo">Stripe</div>
          <div class="div-text">Stripe 支付</div>
        </div>
      </li>
    </ul>

    <!-- Stripe 卡片输入区 -->
    <div class="stripe-card-wrap" v-if="stripeReady && !paying">
      <div id="stripe-card-element"></div>
      <p class="stripe-tip">测试卡号：4242 4242 4242 4242，任意未来有效期/任意CVC</p>
    </div>
    <div v-else-if="!stripeReady" class="stripe-card-wrap stripe-loading">
      {{
        clientSecret ? '正在加载 Stripe 支付，请稍候...' : '请点击"去支付"完成银行卡验证'
      }}
    </div>

    <div class="bnt-pay">
      <div class="bnt-pay-text" style="background-color: #635bff" @click="pay">
        {{ paying ? '支付处理中...' : fieldLabel }}
      </div>
    </div>
  </div>
</template>

<script>
import { getPayPackage, getPayOrderInfo } from '@/api/api'
import config from '@/config'

export default {
  data: function () {
    return {
      avatar: require('../../assets/images/zfb.jpeg'), // 默认商户头像
      iconMemberDefault: require('../../assets/images/zfb.jpeg'),
      amount: null, // 支付金额默认
      payOrderInfo: {}, // 订单信息
      stripe: null, // Stripe 实例
      cardElement: null, // 卡号输入框
      clientSecret: '', // Stripe clientSecret
      publishableKey: '', // Stripe publishableKey
      stripeReady: false, // 卡输入框是否就绪
      paying: false, // 支付提交中
    }
  },

  computed: {
    fieldLabel: function () {
      return this.stripeReady ? '确认支付' : '去支付'
    },
  },

  mounted() {
    this.setPayOrderInfo() // 获取订单信息
  },

  methods: {
    setPayOrderInfo() {
      const that = this
      getPayOrderInfo()
        .then((res) => {
          that.payOrderInfo = res
          if (res.amount) {
            this.amount = res.amount / 100
          }
        })
        .catch((res) => {
          that.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } })
        })
    },

    // 支付入口： 首次点击获取支付包并渲染卡输入，再次点击执行确认支付
    pay: function () {
      if (isNaN(this.amount) || this.amount <= 0) {
        return alert('请输入金额')
      }

      // 已拿到支付包，直接确认支付
      if (this.clientSecret && this.stripeReady) {
        return this.confirmPayment()
      }

      const that = this
      getPayPackage(this.amount)
        .then((res) => {
          if (res.code != '0') {
            return alert(res.msg)
          }
          if (res.data.orderState != 1) {
            // 订单不是支付中，说明订单异常
            return alert(res.data.errMsg)
          }
          // 兼容 payData 为 JSON({publishableKey, clientSecret}) 与纯 clientSecret 字符串两种格式
          const stripePayData = that.parseStripePayData(res.data.payData)
          that.clientSecret = res.data.clientSecret || stripePayData.clientSecret || ''
          that.publishableKey = res.data.publishableKey || stripePayData.publishableKey
          that.renderCardElement()
        })
        .catch((res) => {
          that.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } })
        })
    },

    // 解析 Stripe 支付参数：兼容 JSON 与纯 clientSecret 字符串两种格式
    parseStripePayData: function (payData) {
      if (!payData) {
        return {}
      }
      if (typeof payData === 'object') {
        return payData
      }
      try {
        const parsed = JSON.parse(payData)
        return parsed && typeof parsed === 'object' ? parsed : { clientSecret: payData }
      } catch (e) {
        return { clientSecret: payData }
      }
    },

    // 挂载 Stripe 卡输入框
    async renderCardElement() {
      try {
        await this.loadStripeJs()
        this.stripe = window.Stripe(this.publishableKey)
        const elements = this.stripe.elements()
        this.cardElement = elements.create('card', {
          style: { base: { fontSize: '18px', color: '#32325d' } },
        })
        this.$nextTick(() => {
          this.cardElement.mount('#stripe-card-element')
          this.stripeReady = true
        })
      } catch (e) {
        alert((e && e.message) || 'Stripe 初始化失败')
      }
    },

    // 动态加载 stripe.js
    loadStripeJs() {
      return new Promise((resolve, reject) => {
        if (window.Stripe) {
          return resolve(window.Stripe)
        }
        const script = document.createElement('script')
        script.src = 'https://js.stripe.com/v3/'
        script.onload = () => resolve(window.Stripe)
        script.onerror = () => reject(new Error('Stripe.js 加载失败，请检查网络'))
        document.head.appendChild(script)
      })
    },

    // 确认支付
    async confirmPayment() {
      this.paying = true
      try {
        const result = await this.stripe.confirmCardPayment(this.clientSecret, {
          payment_method: { card: this.cardElement },
        })
        this.paying = false
        if (result.error) {
          return alert((result.error && result.error.message) || '支付失败，请重试')
        }
        // 支付已提交，等待后端 webhook 更新订单状态
        alert('支付已提交，请稍候...')
      } catch (e) {
        this.paying = false
        alert((e && e.message) || '支付异常')
      }
    },
  },
}
</script>
<style lang="css" scoped>
@import './pay.css';

.stripe-logo {
  width: 42px;
  height: 42px;
  margin-right: 30px;
  border-radius: 6px;
  background-color: #635bff;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  line-height: 42px;
}
.stripe-card-wrap {
  width: calc(100vw - 100px);
  margin: 0 auto;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}
.stripe-loading {
  color: #999;
  font-size: 24px;
  text-align: center;
}
.stripe-tip {
  margin-top: 8px;
  color: #999;
  font-size: 20px;
  text-align: center;
}
</style>
